var factory = require('./factory');
module.exports = factory();